import { useEffect, useState } from 'react';
import { isMobileDevice } from '@optimus-web/common';

export const useIsMobileDevice = () => {
    const [isMobile, setIsMobile] = useState(!!isMobileDevice()?.length);

    const handleResize = () => {
        setIsMobile(!!isMobileDevice()?.length);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return isMobile;
};
